export default __webpack_public_path__ + "static/media/ser3.7654c435.svg";